module.exports = __webpack_public_path__ + "img/05.6fd8cb9f.jpg";